// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --secondary-color: #194e54;
  --background-color: #ffffff;
  --button-height: 2.5rem;
  --default-font-size: 1.875rem;
}

.reporting {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
  font-family: 'Inter', sans-serif;
}

.header-container {
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  background: var(--background-color);
  padding: 0 0.625rem;
  margin-top: 1.875rem;
}

.header-button {
  background: var(--background-color);
  color: var(--secondary-color);
  border-radius: var(--border-radius);
  padding: 0.3125rem; 
  font-size: var(--default-font-size);
  font-weight: 600;
  border: 0.125rem solid var(--secondary-color);
  height: var(--button-height);
  width: auto;
}

.header-button:hover {
  background: var(--secondary-color) !important;
  color: white;
}

.content-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: var(--background-color);
  padding: 1.25rem 1.5625rem;
  align-items: center;
  justify-content: center;
  width: 95%;
  margin: -0.625rem; 
}
`, "",{"version":3,"sources":["webpack://./src/styles/Reporting.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,6CAA6C;EAC7C,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB","sourcesContent":[":root {\n  --secondary-color: #194e54;\n  --background-color: #ffffff;\n  --button-height: 2.5rem;\n  --default-font-size: 1.875rem;\n}\n\n.reporting {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  align-items: center;\n  justify-content: flex-end;\n  font-family: 'Inter', sans-serif;\n}\n\n.header-container {\n  width: 100%;\n  justify-content: flex-end;\n  align-items: center;\n  background: var(--background-color);\n  padding: 0 0.625rem;\n  margin-top: 1.875rem;\n}\n\n.header-button {\n  background: var(--background-color);\n  color: var(--secondary-color);\n  border-radius: var(--border-radius);\n  padding: 0.3125rem; \n  font-size: var(--default-font-size);\n  font-weight: 600;\n  border: 0.125rem solid var(--secondary-color);\n  height: var(--button-height);\n  width: auto;\n}\n\n.header-button:hover {\n  background: var(--secondary-color) !important;\n  color: white;\n}\n\n.content-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: var(--background-color);\n  padding: 1.25rem 1.5625rem;\n  align-items: center;\n  justify-content: center;\n  width: 95%;\n  margin: -0.625rem; \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
